import { safeLocale, DEFAULT_LOCALE } from './safeLocale'

export function formatDate(dateString: string, locale: string = DEFAULT_LOCALE): string {
  const date = new Date(dateString)

  return new Intl.DateTimeFormat(safeLocale(locale), {
    year: 'numeric',
    month: 'short',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: true
  }).format(date)
}
